import OrderCURModule from "@/modules/OrderCUR";

function EditOrderPage() {
  return <OrderCURModule type="edit" />;
}

export default EditOrderPage;
